import { useEffect, useState } from "react";
import { _CreditProcessMovement, _single } from "../../../../../../core/services/dataBean/EntityCatalog"
import useDataBean from "../../../../../../core/services/dataBean/useDataBean"
import { BasicPage } from "../../../../../theme/Component/BasicPage"
import { BasicButton } from "../../../../../theme/Component/BasicButton";
import { BasicTable, MASK_DATE, MASK_MONEY, MASK_NUMBER } from "../../../../../theme/Component/BasicTable";
import { ListMenu } from "../../../../../theme/Component/ListMenu";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM, MODAL_XL } from "../../../../../theme/Component/hooks/useModal";
import { Modal } from "../../../../../theme/Component/Modal";
import { YearSelector } from "../../../../../../core/shared/inputs/YearSelector";
import { SelectMonths } from "../../../../../contract/select/SelectMonths";
import { toast } from "react-toastify";
import { ProcessCreditItems } from "./ProcessCreditItems";
import { InputDate } from "../../../../../theme/Input/InputDate";
import { PrintJson } from "../../../../../theme/Component/PrintJson";
import { DocumentViewer } from "../../../../../theme/Component/DocumentViewer";
import { ModalConfirm } from "../../../../../theme/Component/ModalConfirm";
import { PayrollEntitySelect } from "../../../../../admin/CreditPotfolio/PayrollEntity/PayRollEntitySelect";
import { DropDown } from "../../../../../theme/Component/DropDown";
import { ExportXLSL } from "../../../../../theme/Component/ExportXLSX";
import { BasicSwitch } from "../../../../../theme/Component/BasicSwitch";
import { ProcessPaymentView } from "./ProcessPaymentView";

export const ProcessCredit = () => {

    const _credit = useDataBean(_CreditProcessMovement);
    const { setLista, lista, setBean, bean, instance } = _credit;
    const operations = _credit.instance.OPERATION_TYPE;
    const [AccountantDate, setAccountantDate] = useState<any>(undefined);
    const [response, setResponse] = useState<any>({});
    const [param, setParam] = useState<any>({
        Type: _credit.instance.CUOTA_CREDITO
    });
    const modalAdd = useModal("Operación", MODAL_LG);
    const modalItems = useModal("Items de la Operación", MODAL_XL);
    const modalPagos = useModal("Pagos", MODAL_XL);
    const modalContabilizar = useModal("Contabilizar Cuota", MODAL_md);
    const modalDelete = useModal("Eliminar proceso", MODAL_SM);
    const [documents, setDocuments] = useState<any>([]);
    const [listaPeriodo, setListaPeriodo] = useState<any>([]);
    const modalDownload = useModal("Detalle CXC", MODAL_SM);
    const modalDownloadPagos = useModal("Detalle Pagos", MODAL_SM);

    const [year, setYear] = useState<number>(_single.getCurrenYear());
    const [month, setMonth] = useState<number>(_single.getCurrentMonth());


    useEffect(() => {
        setBean({
            IsManual: false
        })
        getOperations();
    }, [])

    const getOperations = () => {

        let filter = {
            TypeProcess: param.Type,
            YearProcess: year,
            MonthProcess: month
        }
        _credit.instance.getCreditProcessMovementRender(1, 10000, filter).then(
            (resp: any) => {
                setLista(resp.List);
            }
        )
    }

    const head = [
        { title: 'ID', property: 'IDCreditProcessMovement', visible: true, mask: MASK_NUMBER },
        { title: 'Periodo', property: 'Periodo', visible: true },
        { title: 'Linea / Caja Nominadora', property: 'LoanLineName', visible: true },
        { title: 'Funcionario', property: 'EmployeeName', visible: true },
        { title: 'Fecha', property: 'Since', visible: true },
        { title: 'Proceso', property: 'IDProcess', visible: true, mask: MASK_NUMBER },
        { title: 'Fecha Proceso', property: 'ProcessDate', visible: true },
        { title: 'Estado', property: 'ProcessStateName', visible: true },
        { title: 'Hash', property: 'HashCode', visible: false, mask: MASK_NUMBER },
    ];
    const headPagos = [
        { title: 'ID', property: 'IDCreditProcessItem', visible: false, mask: MASK_NUMBER },
        { title: 'Fecha Cuota', property: 'CuotaDate', visible: true, mask: MASK_DATE },
        { title: 'Crédito', property: 'CreditNumber', visible: true },
        { title: 'Linea', property: 'LoanName', visible: true },
        { title: 'Identificación', property: 'Nit', visible: true, mask: MASK_NUMBER },
        { title: 'Tercero', property: 'EntityName', visible: true },
        { title: 'Valor Cuota', property: 'VrCuota', visible: true, mask: MASK_MONEY },
        { title: 'Capital Corriente', property: 'CapitalCorriente', visible: true, mask: MASK_MONEY },
        { title: 'Interes Corriente', property: 'InteresCorriente', visible: true, mask: MASK_MONEY },
        { title: 'Capital Mora', property: 'CapitalMora', visible: true, mask: MASK_MONEY },
        // { title: 'Interes Mora Acumulado', property: 'SaldoMoraInteres', visible: true, mask: MASK_MONEY },
        // { title: 'Mayor Valor', property: 'HighestPaidAmount', visible: true, mask: MASK_MONEY },
        { title: 'Interes Mora ', property: 'InteresMora', visible: true, mask: MASK_MONEY },
        { title: 'Saldo Capital', property: 'SaldoCapital', visible: true, mask: MASK_MONEY },
        { title: 'Pago Capital', property: 'PagoCapitalCuota', visible: true, mask: MASK_MONEY },
        { title: 'Pago Interes', property: 'PagoInteresCorrienteCuota', visible: true, mask: MASK_MONEY },
        { title: 'Saldo', property: 'SaldoCapitalCuota', visible: true, mask: MASK_MONEY },

    ];

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { agregar() } }
    ]

    const listaBotones = () => {
        const botones = [
            { titulo: 'Ver Items', icono: 'ri-article-line', visible: true, evento: () => { modalItems.open() } },
            { titulo: 'Ver Recaudos', icono: 'ri-article-fill', visible: [100].includes(bean.TypeProcess), evento: () => { modalPagos.open() } },
            { titulo: 'Contabilizar', icono: 'ri-file-copy-line', visible: ![2].includes(bean.ProcessState), evento: () => { modalContabilizar.open() } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: ![2].includes(bean.ProcessState), evento: () => { modalDelete.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    const agregar = () => {
        setBean(
            {
                Year: _single.getCurrenYear(),
                Month: _single.getCurrentMonth(),
                IsManual: false
            }
        );
        modalAdd.open();
    }

    const generarProceso = () => {
        let obj = {
            IDLoanLine: bean.IDLoanLine,
            IDPayrollEntity: bean.IDPayrollEntity,
            Year: bean.Year,
            Month: bean.Month,
            IsManual: bean.IsManual
        }
        let operation = {
            DataBeanName: "com.credit.bean.CreditProcessMovement",
            DataBeanProperties: {
                IDEmployee: _single.getAccountID(),
                TypeProcess: param.Type,
                State: 1,
                ProcessData: JSON.stringify(obj)
            }
        }
        console.log(operation);

        _credit.instance.addCreditProcessMovement(_single.getAccountID(), operation).then(
            (resp: any) => {
                console.log(resp);
                modalAdd.close();
                toast.success("Proceso iniciado recibira un correo notificando la finalización del proceso");
                getOperations();

            }
        )
    }
    const createQuotaCredit = () => {
        const data = JSON.parse(bean.ProcessData ?? "{}");

        _credit.instance.createQuotaCreditThread(AccountantDate, bean.IDCreditProcessMovement, 201, _single.getAccountID()).then(
            (resp: any) => {
                // setResponse(resp);
                // if(resp.ReportList)
                // {
                //     setDocuments(resp.ReportList);
                // }
                toast.success("El proceso inicio la ejecucion recibira una notificación al finalizar.");
                modalContabilizar.close();
            }
        )


    }
    const deleteProcess = () => {
        _credit.instance.removeCreditProcessMovement(bean.IDCreditProcessMovement).then(
            (resp: any) => {
                getOperations();
                modalDelete.close();
            }
        )
    }

    const actionsDropDown = [
        { id: 1, name: 'Reporte Periodo', permiso: null, activo: true },
        { id: 2, name: 'Reporte Pagos Periodo', permiso: null, activo: true },

    ];

    const getCreditProcessItemRender = () => {
        const props: any = {
            // IDCreditProcessMovement: bean.IDCreditProcessMovement
            Periodo: bean.Periodo
        }


        _credit.instance.getCreditProcessItemRender(1, 10000, props).then(
            (resp: any) => {
                if (resp.List) {
                    resp.List.forEach(element => {
                        element.DataBeanProperties.VrCuota =
                            // element.DataBeanProperties.InteresMora +
                            element.DataBeanProperties.InteresCorriente +
                            // element.DataBeanProperties.CapitalMora +
                            element.DataBeanProperties.CapitalCorriente;
                    });
                    setListaPeriodo(resp.List);
                    modalDownload.open();
                }
            }
        )
    }
    const getPagos = () => {
        instance.getCreditProcessItemWhitPaymentRender(1, 10000, { Periodo: bean.Periodo }).then(
            (resp: any) => {
                setListaPeriodo(resp.List);
                modalDownloadPagos.open();
            }
        )
    }

    const head2 = [
        { title: 'ID', property: 'IDCreditProcessItem', visible: false, mask: MASK_NUMBER },
        { title: 'Fecha Cuota', property: 'CuotaDate', visible: true, mask: MASK_DATE },
        { title: 'Crédito', property: 'CreditNumber', visible: true },
        { title: 'Linea', property: 'LoanName', visible: true },
        { title: 'Identificación', property: 'Nit', visible: true, mask: MASK_NUMBER },
        { title: 'Tercero', property: 'EntityName', visible: true },
        { title: 'Valor Cuota', property: 'VrCuota', visible: true, mask: MASK_MONEY },
        { title: 'Capital Corriente', property: 'CapitalCorriente', visible: true, mask: MASK_MONEY },
        { title: 'Interes Corriente', property: 'InteresCorriente', visible: true, mask: MASK_MONEY },
        { title: 'Capital Mora', property: 'CapitalMora', visible: true, mask: MASK_MONEY },
        { title: 'Interes Mora', property: 'InteresMora', visible: true, mask: MASK_MONEY },
        { title: 'Saldo Capital', property: 'SaldoCapital', visible: true, mask: MASK_MONEY },
        { title: 'Fecha Contabilización', property: 'AccountingDate', visible: true, mask: MASK_DATE },
        { title: 'ID Registro', property: 'IDPaymentItem', visible: false, mask: MASK_NUMBER },
        { title: 'Fecha Registro', property: 'PaymentItemDate', visible: false },
        { title: 'Mensaje', property: 'ErrorMessage', visible: true }
    ]

    const buttons = () => {
        return (
            <div className="row">
                <div className="col-md-12">
                    {bean.IDCreditProcessMovement &&
                        <DropDown lista={actionsDropDown} eventClick={(e) => {
                            if (e.id == 1) {
                                getCreditProcessItemRender();
                            }
                            else if (e.id == 2) {
                                getPagos();
                            }
                        }}></DropDown>
                    }
                </div>
            </div>
        )
    }

    return (
        <BasicPage titulo="Procesos Crédito y Cartera">
            <div className="row">
                <div className="col-md-3">
                    <YearSelector tittle="Año" value={year} onChange={(e) => { setYear(e) }} />
                </div>
                <div className="col-md-3">
                    <SelectMonths label="Mes" idSelector={month} onChange={(e) => { setMonth(e) }} />
                </div>
                <div className="col-md-6">
                    <label>Operación</label>
                    <select name="ope" className="form-select" value={param.Type} onChange={(e) => { setParam({ ...param, "Type": parseInt(e.target.value) }) }}>
                        {operations.map((item: any) => {
                            return (
                                <option value={item.id}>{item.name}</option>
                            )
                        })}
                    </select>
                </div>
                <div className="col-md-4 ">
                    <BasicButton icon="" useMargin eventClick={getOperations}>Buscar</BasicButton>
                </div>
                <div className="col-md-12">
                    <BasicTable headButtons={buttons()} head={head} body={lista} rowSet={setBean} iconButtons={iconButtonsItem} listButtons={listaBotones()} ></BasicTable>
                    {/* <PrintJson json={response}/>
                     */}
                    {documents.length > 0 &&
                        <DocumentViewer list={documents} />
                    }
                    <Modal modal={modalAdd.modal} updateModal={modalAdd.setModal} eventModal={generarProceso} onSubmitLabel="Procesar" >
                        <div className="row">
                            <div className="col-md-3">
                                <YearSelector value={bean.Year} onChange={(e) => { setBean({ ...bean, "Year": e }) }} />
                            </div>
                            <div className="col-md-3">
                                <SelectMonths idSelector={bean.Month} onChange={(e) => { setBean({ ...bean, "Month": e }) }} />
                            </div>
                            <div className="col-md-6 mt-1">
                                <BasicSwitch label="Listado Manual" estado={bean.IsManual ?? false} eventChange={(e) => { setBean({ ...bean, "IsManual": e }) }} />
                                <span>Para agregar créditos manualmente</span>
                            </div>
                            {[100].includes(param.Type) &&
                                <>
                                    <div className="col-md-6">
                                        {bean.IsManual === false &&
                                            <PayrollEntitySelect idSelector={bean.IDPayrollEntity} onChange={(e) => { setBean({ ...bean, "IDPayrollEntity": e }) }} />
                                        }
                                    </div>
                                </>
                            }
                        </div>
                    </Modal>

                    <Modal modal={modalItems.modal} updateModal={modalItems.setModal}>
                        <ProcessCreditItems idCreditProcessMovement={bean.IDCreditProcessMovement} typeProcess={bean.TypeProcess} stateProcessMovement={bean.ProcessState} yearProcess={bean.YearProcess} monthProcess={bean.MonthProcess} />
                    </Modal>
                    <Modal modal={modalPagos.modal} updateModal={modalPagos.setModal}>
                        <ProcessPaymentView idCreditProcessMovement={bean.IDCreditProcessMovement} />
                    </Modal>
                    <Modal modal={modalContabilizar.modal} updateModal={modalContabilizar.setModal} eventModal={createQuotaCredit} onSubmitLabel="Contabilizar">
                        <div className="row">
                            <div className="col-md-12">
                                <InputDate value={AccountantDate} name="Fecha" label="Fecha de Contabilización" setDate={(e) => { setAccountantDate(e) }} />
                            </div>
                        </div>
                    </Modal>
                    <ModalConfirm modal={modalDelete.modal} updateModal={modalDelete.setModal} eventModal={deleteProcess}>
                        <p>Eliminar Proceso</p>
                    </ModalConfirm>

                    <Modal modal={modalDownload.modal} updateModal={modalDownload.setModal}>
                        <div className="row">
                            <div className="col-md-12">
                                {listaPeriodo.length > 0 &&
                                    <ExportXLSL customName={'cartera'} optionIcon="ri-download-cloud-2-line text-success" title={head2} data={listaPeriodo} onExport={(name: string) => {
                                        _single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                                    }} />
                                }
                            </div>
                        </div>
                    </Modal>
                    <Modal modal={modalDownloadPagos.modal} updateModal={modalDownloadPagos.setModal}>
                        <div className="row">
                            <div className="col-md-12">
                                {listaPeriodo.length > 0 &&
                                    <ExportXLSL customName={'pagos'} optionIcon="ri-download-cloud-2-line text-success" title={headPagos} data={listaPeriodo} onExport={(name: string) => {
                                        _single.download("formato xlsx [" + name + "] con " + lista.length + " registros");
                                    }} />
                                }
                            </div>
                        </div>
                    </Modal>
                </div>
            </div>
        </BasicPage>
    )
}